import {ModuleRouteManifest} from '../types'

export const studentClearanceRouteManifest: ModuleRouteManifest = {
  code: 'student-clearance',
  privateRoutes: ['student-clearance', 'student-clearance-request'],
}
